export default __webpack_public_path__ + "4c3f26baa0345f3c5dfee7ad917b4991.svg";